import { render, staticRenderFns } from "./CreateChatBotMessageModal.vue?vue&type=template&id=3b849cec"
import script from "./CreateChatBotMessageModal.vue?vue&type=script&lang=js"
export * from "./CreateChatBotMessageModal.vue?vue&type=script&lang=js"
import style0 from "./CreateChatBotMessageModal.vue?vue&type=style&index=0&id=3b849cec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports